import { Component, Input, OnInit, inject } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import {
  Level1ReviewerRoles,
  Level2ReviewerRoles,
  WorkloadAdminRoles,
} from 'projects/bis-shared/src/lib/utility/roles';
import * as _ from 'lodash';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { ActivePriorAuthListProviderComponent } from './active-prior-auth-list-provider/active-prior-auth-list-provider.component';
import { InActivePriorAuthListComponent } from './inactive-prior-auth-list/inactive-prior-auth-list.component';
import { ActivePriorAuthListInsurerMyOrgComponent } from './active-prior-auth-list-insurer-my-org/active-prior-auth-list-insurer-my-org.component';
import { PriorAuthSearchComponent } from './prior-auth-search/prior-auth-search.component';
import { ActivePriorAuthListInsurerMyParsComponent } from './active-prior-auth-list-insurer-my-pars/active-prior-auth-list-insurer-my-pars.component';

@Component({
  selector: 'app-priorauth-queue-component',
  templateUrl: './prior-auth-queue.component.html',
  styleUrls: ['./prior-auth-queue.component.scss'],
  imports: [
    MatCardModule,
    MatTabsModule,
    CommonModule,
    ActivePriorAuthListProviderComponent,
    InActivePriorAuthListComponent,
    ActivePriorAuthListInsurerMyOrgComponent,
    PriorAuthSearchComponent,
    ActivePriorAuthListInsurerMyParsComponent,
  ], 
})
export class PriorAuthQueueComponent implements OnInit {
  private identityService = inject(IdentityService);

  @Input() isInsurerUser: boolean;
  isWorkloadAdminUser: boolean = false;
  isLevelReviewerUser: boolean = false;

  
 

  

  ngOnInit(): void {
    this.isWorkloadAdminUser = this.identityService.hasAnyRoles(WorkloadAdminRoles);
    this.isLevelReviewerUser = this.identityService.hasAnyRoles(
      _.union(Level1ReviewerRoles, Level2ReviewerRoles),
    );
  }
}
